import React, {Component} from 'react';
import {DocumentTitle} from '../widgets';
import NewsSection from '../home/NewsSection';
import './NewsPress.css';

class NewsPress extends Component {
	render() {
		return (
			<DocumentTitle title="B2Me">
				<main className="NewsPress">
					<NewsSection />
				</main>
			</DocumentTitle>
		);
	}
}

export default NewsPress;



// WEBPACK FOOTER //
// ./src/pages/NewsPress.js